import { sanitized, SanitizeMode } from 'util/sanitized';
import { IListItem } from 'components/common/CollapsableList/type';

export interface IHTMLParsedData {
  text: string
  list: Array<IListItem>
}

const getInfoList = (notParsedInfo: string) => {
  const notParsedList = notParsedInfo.split('<h3>');
  const parsed: Array<IListItem> = notParsedList.reduce<Array<IListItem>>((acc: Array<IListItem>, notParsedItem: string) => {
    const splitted = notParsedItem.split('</h3>');
    if (notParsedItem) {
      acc.push({
        title: `<h3>${splitted[0]}</h3>`,
        description: splitted[1],
      });

      return acc;
    }
    return acc;
  }, [] as Array<IListItem>);
  return parsed;
};

export const parseHTMLtoList = (text: string, placeholders: Record<string, string> = {}): IHTMLParsedData => {
  // clear incomming HTML markup from unexpected string ends e.t.c.
  let dataListInText = text?.replace(/(?:\\[rn]|[\r\n]+)+/g, '');
  Object.keys(placeholders).forEach((key) => {
    dataListInText = dataListInText.split(`{{${key}}}`).join(placeholders[key]);
  });
  const { dangerouslySetInnerHTML: { __html: sanitizedIText } } = sanitized(dataListInText, SanitizeMode.Partial);

  const returnedValue: IHTMLParsedData = {
    text: sanitizedIText,
    list: [],
  };

  if (dataListInText) {
    const firstH3index = dataListInText.indexOf('<h3>');
    const pureText = dataListInText.substring(0, firstH3index === -1 ? dataListInText.length : firstH3index);
    const itemsText = dataListInText.substring(firstH3index);
    const containHeaders = itemsText.includes('<h3>');

    if (containHeaders) {
      const { dangerouslySetInnerHTML: { __html: sanitizedItemsText } } = sanitized(itemsText, SanitizeMode.Partial);
      const { dangerouslySetInnerHTML: { __html: sanitizedPureText } } = sanitized(pureText, SanitizeMode.Partial);

      returnedValue.text = sanitizedPureText;
      returnedValue.list = getInfoList(sanitizedItemsText);
    }
  }

  return returnedValue;
};
